import React from 'react';
import {colors} from '../theme/tokens/colors';

export interface CashIconProps {
  color?: keyof typeof colors;
  size?: number;
}

export const CashIcon = React.memo<CashIconProps>(
  ({color = 'outlines', size = 18}) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.10345 4.02206H15.8966V5.65859H2.10345L2.10345 4.02206ZM2.10345 8.93132L2.10345 13.8402H15.8966V8.93132H2.10345ZM1 4.02206C1 3.41957 1.49403 2.93115 2.10345 2.93115H15.8966C16.506 2.93115 17 3.41957 17 4.02206V13.8402C17 14.4427 16.506 14.9312 15.8966 14.9312H2.10345C1.49403 14.9312 1 14.4427 1 13.8402V4.02206Z"
        fill={colors[color] || color}
      />
    </svg>
  ),
);
